import React from 'react';
import { Redirect } from 'react-router-dom';

import useUser from '../../hooks/useUser';
import usePrerenderReady from '../../hooks/usePrerenderReady';
import GoogleOAuthBoundary from '../../components/auth/GoogleOAuthBoundary';
import { LandingPage, LandingSeo } from '../components';
import { createHomeStructuredData, homeSeo } from './homeLandingContent';
import { isPrerendering } from '../../services/prerender';
import ApiFeaturesSection from './sections/ApiFeaturesSection';
import CoverageSection from './sections/CoverageSection';
import CustomersSection from './sections/CustomersSection';
import GuidesSection from './sections/GuidesSection';
import HomeHero from './sections/HomeHero';
import McpSection from './sections/McpSection';
import PricingSection from './sections/PricingSection';

import '@rmwc/tooltip/styles';
import '@rmwc/button/styles';

function HomeLanding() {
  const [user, isAuthInitializing] = useUser();
  usePrerenderReady(!isAuthInitializing, 'home', {
    selectors: ['.landing-page h1', '#mcp-server', '#pricing', 'script[type="application/ld+json"]'],
    canonical: homeSeo.canonicalUrl,
    jsonLdType: 'SoftwareApplication'
  });

  if (isAuthInitializing) {
    return <div className="bg vh-100 d-flex align-items-center justify-content-center"><div className="spinner" aria-label="Restoring session"><div className="bounce1"></div><div className="bounce2"></div><div className="bounce3"></div></div></div>;
  }

  if (user && !isPrerendering()) return <Redirect to={{ pathname: '/dashboard' }} />;

  return <GoogleOAuthBoundary>
    <LandingPage>
      <LandingSeo {...homeSeo} structuredData={createHomeStructuredData()} />
      <HomeHero />
      <ApiFeaturesSection />
      <CoverageSection />
      <McpSection />
      <CustomersSection />
      <GuidesSection />
      <PricingSection />
    </LandingPage>
  </GoogleOAuthBoundary>;
}

export default HomeLanding;
